const description = {
    email: 'email',
    phone_number: 'phone number',
    username: 'username',
    reminder: 'Reminder',
    not_found: 'Page not found',
    not_found_description: 'The link may be broken, or the page may have been moved.',
    agree_with_terms: 'I have read and agree to the <link></link>.',
    agree_with_terms_modal: 'To proceed, please agree to the <link></link>.',
    terms_of_use: 'Terms of Use',
    sign_in: 'Sign in',
    privacy_policy: 'Privacy Policy',
    create_account: 'Create account',
    switch_account: 'Switch account',
    or: 'or',
    and: 'and',
    enter_passcode: 'Enter the code sent to your {{address}} {{target}}.',
    // WhatsApp is an SMS-type connector in Logto; when the phone code is delivered over
    // WhatsApp, the passwordless verification screen labels the channel accurately
    // (mirrors the MFA phone screen's `via_whatsapp` copy so all surfaces read the same).
    enter_passcode_via_whatsapp: 'Enter the code sent on WhatsApp to {{target}}.',
    passcode_sent: 'New code sent',
    resend_after_seconds: 'Didn’t get the code? Resend in <span>{{seconds}}</span> seconds',
    resend_passcode: 'Didn’t get the code? <a>Resend code</a>',
    create_account_id_exists: 'An account with {{value}} already exists. Sign in instead?',
    link_account_id_exists: 'An account with {{type}} {{value}} already exists. Link it to continue?',
    sign_in_id_does_not_exist: 'No account found for {{value}}. Create a new one?',
    sign_in_id_does_not_exist_alert: 'No account found with {{type}} {{value}}.',
    create_account_id_exists_alert: 'An account with {{type}} {{value}} already exists. Try another {{type}}.',
    social_identity_exist: 'The {{type}} {{value}} is linked to another account. Please try another {{type}}.',
    bind_account_title: 'Link or create account',
    social_create_account: 'You can create a new account.',
    social_link_email: 'You can link another email',
    social_link_phone: 'You can link another phone',
    social_link_email_or_phone: 'You can link another email or phone',
    social_bind_with_existing: 'An account with these details already exists. Link it to continue.',
    skip_social_linking: 'Skip linking to existing account?',
    account_linked: 'Account linked',
    reset_password: 'Reset password',
    reset_password_description: 'Enter the {{types, list(type: disjunction;)}} on your account and we’ll send you a code to reset your password.',
    reset_password_magic_link_description: 'Enter the email address associated with your account to continue resetting your password.',
    new_password: 'New password',
    set_password: 'Set password',
    password_changed: 'Password changed',
    no_account: 'No account yet? ',
    have_account: 'Already have an account?',
    enter_password: 'Enter password',
    enter_password_for: 'Sign in with the password to {{method}} {{value}}',
    enter_username: 'Set username',
    enter_username_description: 'You can also sign in with your username. Use only letters, numbers, and underscores.',
    enter_username_policy_description: 'You can also sign in with your username. {{requirements}}',
    link_email: 'Link email',
    link_phone: 'Link phone',
    link_email_or_phone: 'Link email or phone',
    link_email_description: 'For added security, please link your email with the account.',
    link_phone_description: 'For added security, please link your phone with the account.',
    link_email_or_phone_description: 'For added security, please link your email or phone with the account.',
    continue_with_more_information: 'For added security, please complete below account details.',
    create_your_account: 'Create your Hypedrive account',
    sign_in_to_your_account: 'Sign in to Hypedrive',
    auth_subtitle: 'One account for all of Hypedrive.',
    auth_value_campaigns: 'Your campaigns and orders in one place',
    auth_value_cashback: 'Track the status of each one',
    auth_value_payouts: 'Secure sign-in across Hypedrive apps',
    // Chip shown next to the sign-in option that last succeeded in this browser. Keep it short
    // — it renders inside a pill beside the option's label.
    last_used: 'Last used',
    device_activation: 'Device activation',
    device_activation_description: 'Enter the code shown on your device. Make sure it matches, then continue to sign in to this device.',
    device_activation_error_description: 'Enter the code displayed on your device.',
    device_activation_success: 'Device connected',
    device_activation_success_description: 'Return to your device to continue.',
    no_region_code_found: 'No region code found',
    verify_email: 'Verify your email',
    verify_phone: 'Verify your phone number',
    // Channel-accurate title when the phone code is delivered over WhatsApp.
    verify_phone_via_whatsapp: 'Verify your WhatsApp number',
    password_requirements: 'Use {{items, list}}.',
    password_requirement: {
        length_one: 'at least {{count}} character',
        length_two: 'at least {{count}} characters',
        length_few: 'at least {{count}} characters',
        length_many: 'at least {{count}} characters',
        length_other: 'at least {{count}} characters',
        character_types_one: 'at least {{count}} of: uppercase letters, lowercase letters, numbers, and symbols',
        character_types_two: 'at least {{count}} of: uppercase letters, lowercase letters, numbers, and symbols',
        character_types_few: 'at least {{count}} of: uppercase letters, lowercase letters, numbers, and symbols',
        character_types_many: 'at least {{count}} of: uppercase letters, lowercase letters, numbers, and symbols',
        character_types_other: 'at least {{count}} of: uppercase letters, lowercase letters, numbers, and symbols',
    },
    username_requirements: 'Username {{items, list}}.',
    username_requirement: {
        length: 'must be {{min}} to {{max}} characters',
        characters: 'can only contain {{characters, list}}',
    },
    username_character: {
        uppercase: 'uppercase letters',
        lowercase: 'lowercase letters',
        number: 'numbers',
        underscore: 'underscores',
    },
    use_single_sign_on: 'Use <a>single sign-on</a>',
    single_sign_on_email_form: 'Enter your enterprise email address',
    single_sign_on_connectors_list: 'Your organization uses single sign-on for {{email}}. Continue with one of these providers.',
    single_sign_on_enabled: 'Single sign-on is enabled for this account',
    authorize_title: 'Authorize {{name}}',
    unregistered_client_notice: 'This app is self-declared by <hostname>{{host}}</hostname>, including its name and logo. Please verify the hostname before you continue.',
    request_permission: '{{name}} is requesting access to:',
    grant_organization_access: 'Grant the organization access:',
    authorize_personal_data_usage: 'Authorize the use of your personal data:',
    authorize_organization_access: 'Choose an organization to share:',
    user_scopes: 'Personal user data',
    organization_scopes: 'Organization access',
    authorize_agreement: 'By authorizing, you agree to {{name}}’s <link></link>.',
    authorize_agreement_with_redirect: 'By authorizing, you agree to {{name}}’s <link></link>. You’ll then go to {{uri}}.',
    not_you: 'Not you?',
    user_id: 'User ID: {{id}}',
    redirect_to: 'You will be redirected to {{name}}.',
    auto_agreement: 'By continuing, you agree to the <link></link>.',
    identifier_sign_in_description: 'Enter your {{types, list(type: disjunction;)}} to sign in.',
    all_sign_in_options: 'All sign-in options',
    identifier_register_description: 'Enter your {{types, list(type: disjunction;)}} to create a new account.',
    all_account_creation_options: 'All account creation options',
    back_to_sign_in: 'Back to sign in',
    password_expired: 'Your password has expired and must be reset before you can sign in.',
    password_expiration_reset: 'Reset password',
    support_email: 'Support email: <link></link>',
    support_website: 'Support website: <link></link>',
    switch_account_title: 'You are currently signed in as {{account}}',
    switch_account_description: 'To continue, you’ll be signed out of this account and signed in to the new one.',
    about_yourself: 'Tell us about yourself',
    verify_identity: 'Verify your identity',
    choose_verification_method: 'Choose how you want to sign in',
    signing_you_in: 'Signing you in…',
    loading: 'Loading…',
    select_wallet: 'Select a wallet',
    verification_method: {
        passkey: 'Passkey',
        passkey_description: 'Verify via your device or USB hardware',
        password: 'Password',
        password_description: 'Enter your password',
        email_verification_code: 'Email verification code',
        phone_verification_code: 'Phone verification code',
        verification_code_description: 'Send to {{target}}',
    },
};
export default Object.freeze(description);
